import React from "react";
import PropTypes from "prop-types";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CardBody from "components/Card/CardBody.js";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Config from "conFig.js";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const chuyenmoncolumn = [
  { field: "id", headerName: "ID", width: 50, hide: true },
  {
    field: "tentruong",
    headerName: "Tên trường",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "chuyennganh",
    headerName: "Chuyên nghành đào tạo, bồi dưỡng",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "khoangthoigian",
    headerName: "Từ tháng, năm, đến tháng, năm",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "hinhthucdaotao",
    headerName: "Hình thức đào tạo",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "vanbang",
    headerName: "Văn bằng, chứng chỉ, trình độ gì",
    width: 250,
    headerAlign: "center",
  },
];
const taphuancolumn = [
  { field: "id", headerName: "ID", width: 50, hide: true },
  {
    field: "tenlop",
    headerName: "Tên lớp tập huấn",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "diadiem",
    headerName: "Địa điểm tập huấn",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "khoangthoigian",
    headerName: "Từ ngày, tháng, năm, đến ngày, tháng, năm",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "ketqua",
    headerName: "Kết quả",
    width: 250,
    headerAlign: "center",
  },
];
const congtaccolumn = [
  { field: "id", headerName: "ID", width: 50, hide: true },
  {
    field: "khoangthoigian",
    headerName: "Từ tháng, năm, đến tháng, năm",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "chucdanh",
    headerName: "Chức danh",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "chucvu",
    headerName: "Chức vụ",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "donvicongtac",
    headerName: "Đơn vị công tác",
    width: 250,
    headerAlign: "center",
  },
];
const Capnhatpdkv = React.memo(function Capnhatpdkv(props) {
  const { dangkiemvienid } = props;
  const [hoten, setHoten] = React.useState("");
  const [cccd, setCccd] = React.useState("");
  const [trinhdo, setTrinhdo] = React.useState("");
  const [tentrungtam, setTentrungtam] = React.useState("");
  const [chuyenmon, setChuyenmon] = React.useState([]);
  const [taphuan, setTaphuan] = React.useState([]);
  const [congtac, setCongtac] = React.useState([]);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const getdkvtheoid = () => {
    var url =
      Config.backend +
      "/api/DangKiemVien/getdangkiemvientheoid?id=" +
      dangkiemvienid +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setHoten(data[0].ten);
        setCccd(data[0].cccd);
        setTrinhdo(data[0].trinhdocm);
        setTentrungtam(data[0].trungtamdangkiem);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getdaotaochuyenmon = () => {
    var url =
      Config.backend +
      "/api/DangKiemVien/getdangkiemvientheodkvid?dangkiemvien_id=" +
      dangkiemvienid +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setChuyenmon(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const gettaphuan = () => {
    var url =
      Config.backend +
      "/api/DangKiemVien/getdangkiemvientaphuantheodkvid?dangkiemvien_id=" +
      dangkiemvienid +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTaphuan(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getcongtac = () => {
    var url =
      Config.backend +
      "/api/DangKiemVien/getdangkiemvienqtcttheodkvid?dangkiemvien_id=" +
      dangkiemvienid +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setCongtac(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  React.useEffect(() => {
    getdkvtheoid();
    getdaotaochuyenmon();
    gettaphuan();
    getcongtac();
  }, []);
  return (
    <div style={{ height: 550, overflowY: "auto" }}>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 10 }}>
              <TextField
                label="Họ và tên"
                variant="outlined"
                size="small"
                value={hoten}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 10 }}>
              <TextField
                label="Số căn cước công dân"
                variant="outlined"
                size="small"
                value={cccd}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <FormControl style={{ width: "100%", marginTop: 10 }}>
              <TextField
                label="Trình độ chuyên môn cao nhất"
                variant="outlined"
                size="small"
                value={trinhdo}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} style={{ marginTop: 10 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Tên trung tâm"
                variant="outlined"
                size="small"
                value={tentrungtam}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "100%", fontWeight: "bold" }}>
              1. Đào tạo chuyên môn
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <div style={{ height: 180, width: "100%" }}>
              <DataGrid
                getRowId={(row) => row.id}
                rows={chuyenmon}
                columns={chuyenmoncolumn}
                checkboxSelection={false}
                getRowHeight={() => "auto"}
                headerHeight={35}
                hideFooter={true}
                sx={datagridSx}
                initialState={{
                  filter: {
                    filterModel: {
                      items: [],
                      quickFilterLogicOperator: GridLinkOperator.Or,
                    },
                  },
                }}
                components={{ Toolbar: quickSearchToolbar }}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "100%", fontWeight: "bold" }}>
              2. Tập huấn nghiệp vụ đăng kiểm xe cơ giới
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <div style={{ height: 180, width: "100%" }}>
              <DataGrid
                getRowId={(row) => row.id}
                rows={taphuan}
                columns={taphuancolumn}
                checkboxSelection={false}
                getRowHeight={() => "auto"}
                headerHeight={35}
                hideFooter={true}
                sx={datagridSx}
                initialState={{
                  filter: {
                    filterModel: {
                      items: [],
                      quickFilterLogicOperator: GridLinkOperator.Or,
                    },
                  },
                }}
                components={{ Toolbar: quickSearchToolbar }}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <FormControl style={{ width: "100%", fontWeight: "bold" }}>
              3. Tóm tắt quá trình công tác
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
            <div style={{ height: 180, width: "100%" }}>
              <DataGrid
                getRowId={(row) => row.id}
                rows={congtac}
                columns={congtaccolumn}
                checkboxSelection={false}
                getRowHeight={() => "auto"}
                headerHeight={35}
                hideFooter={true}
                sx={datagridSx}
                initialState={{
                  filter: {
                    filterModel: {
                      items: [],
                      quickFilterLogicOperator: GridLinkOperator.Or,
                    },
                  },
                }}
                components={{ Toolbar: quickSearchToolbar }}
              />
            </div>
          </GridItem>
        </GridContainer>
      </CardBody>
    </div>
  );
});

Capnhatpdkv.propTypes = {
  dangkiemvienid: PropTypes.number,
};
export default Capnhatpdkv;
